import Transformer from '../../transformer'
import assetURL from '../../../utils/assetURL'

export default class SupplyTransformer extends Transformer {
  static fetch(Hsupply) {
    return {
      id: Hsupply.id,
      isActive: Hsupply.is_active,
      previousSupply: Hsupply.previous_supply,
      price: Hsupply.price,

      sSupplyAddDate: (Hsupply.supply) ? Hsupply.supply.add_date : null,
      sSupplyCode: Hsupply.supply.code,
      sSupplyComment: Hsupply.supply.comment,
      sSupplyId: Hsupply.supply.id,
      sSupplyImage: assetURL(Hsupply.supply.image),
      sSupplyisActive: Hsupply.supply.is_active,
      sSupplyisDivisible: Hsupply.supply.is_divisible,
      sSupplylastModified: Hsupply.supply.last_modified,
      sSupplyName: Hsupply.supply.name,
      sSupplySctCode: Hsupply.supply.sct_code,
      sSupplySubFamilyId: Hsupply.supply.subfamily,
      sSupplySupplyTypeId: Hsupply.supply.supply_type,
      sSupplyUnitMeasurementId: Hsupply.supply.unit_measurement,
      sSupplyUnitWeight: Hsupply.supply.unit_weight,

      campId: Hsupply.camp.SupplyCamp_camp_id,
      campName: Hsupply.camp.SupplyCamp_camp_name,

      providerId: Hsupply.provider.SupplyHighway_provider_id,
      providerName: Hsupply.provider.SupplyHighway_provider_name,

      quotation: Hsupply.quotation,
      campName: Hsupply.camp.SupplyCamp_camp_name,
    }
  }

  static send(Hsupply) {
    return{
      id:Hsupply.id,
      supply: Hsupply.sSupplyId,
      camp: Hsupply.campId,
      provider: Hsupply.providerId,
      price: Hsupply.price,
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/catalog/supplys/supplyHighway.js